//import "antd/dist/antd.css";
import "antd/dist/antd.min.css";
import "./App.css";
import { Menu } from "antd";
// import {Routes} from './routes/Routes';
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  HomeOutlined,
  UnorderedListOutlined,
  UserOutlined,
  PoweroffOutlined,
} from "@ant-design/icons/lib/icons";
//import HookMqtt from './components/Hook';
import Iot1 from "./components/Iot1";
import Iot2 from "./components/Iot2";
// import HooksPersonalizados from "./components/HooksPersonalizados";
import Hw1 from "./components/Hw1";
import Hw2 from "./components/Hw2";
import Hw3 from "./components/Hw3";
import Header2 from "./components/Header2";


//} from "@ant-design/icons";

function App() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100vh",
      }}
    >
      <Header2 />
      {/* <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        <SideMenu />
        <Content />
      </div> */}
        <SideMenu />
        <Content />
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <div
      style={{
        height: 60,
        backgroundColor: "lightskyblue",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
      }}
    >
      Header
    </div>
  );
}

function Footer() {
  return (
    <div
      style={{
        height: 60,
        backgroundColor: "lightgray",
        color: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
      }}
    >
      Footer
    </div>
  );
}

function SideMenu() {
  const navigate = useNavigate();
  //console.log(window.screen.orientation);
  return (
    //<Menu theme="dark" mode="horizontal"
    <Menu 
     mode="horizontal"
    //mode="vertical"
      onClick={({ key }) => {
        if (key === "signout") {
          //TODO, sign out feature here
        } else {
          navigate(key);
        }
      }}
      defaultSelectedKeys={[window.location.pathname]}
      items={[
        { label: "Home", key: "/", icon: <HomeOutlined /> },
        //{ label: "Home", key: "/" },
        {
          label: "Hw1",
          key: "/hw1",
          icon: <DashboardOutlined />,
        },
        {
          label: "Hw2",
          key: "/hw2",
          icon: <DashboardOutlined />,
        },
        {
          label: "Hw3",
          key: "/hw3",
          icon: <DashboardOutlined />,
        },
        {
          label: "Dash1",
          key: "/dash1",
          icon: <DashboardOutlined />,
        },
        {
          label: "Dash2",
          key: "/dash2",
          icon: <DashboardOutlined />,
        },
        {
          label: "Iot 1",
          key: "/iot1",
          icon: <DashboardOutlined />,
        },
        {
          label: "Iot 2",
          key: "/iot2",
          icon: <DashboardOutlined />,
        },
        {
          label: "User List",
          key: "/userList",
          icon: <UnorderedListOutlined />,
          children: [
            { label: "Active Users", key: "/activeUsers" },
            { label: "Disabled Users", key: "/disabledUsers" },
          ],
        },
        { 
          label: "Profile", 
          key: "/profile", 
          icon: <UserOutlined /> 
        },
        {
          label: "Singout",
          key: "signout",
          icon: <PoweroffOutlined />,
          danger: true,
        },
      ]}
    ></Menu>
  );
}

function Home() {
  return <div>Home Component</div>;
}

function Content() {
  return (
    <div className="Contenido">
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/hw1" element={<Hw1 />}></Route>
        <Route path="/hw2" element={<Hw2 />}></Route>
        <Route path="/hw3" element={<Hw3 />}></Route>
        <Route path="/dash1" element={<div>
          {/* <HooksPersonalizados/> */}
        </div>}></Route>
        {/* <Route path="/dash2" element={<HookMqtt />}></Route> */}
        <Route path="/iot1" element={<Iot1 />}></Route>
        <Route path="/iot2" element={<Iot2 />}></Route>
        <Route
          path="/activeUsers"
          element={<div>Active Users List</div>}
        ></Route>
        <Route
          path="/disabledUsers"
          element={<div>Disabled Users List</div>}
        ></Route>

        <Route path="/profile" element={<div>Profile</div>}></Route>
      </Routes>
    </div>
  );
}

export default App;
